import styled, { css, keyframes } from 'styled-components';

import { Box } from '../../units/Box/Box';
import Header from '../../units/Header/Header';
import Icon from '../../units/Icon/Icon';

const opacity = {
  default: 1,
  full: 0,
  translucent: 0.4
};

const animations = {
  rotate360: keyframes`
    0% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(100deg);
    }
    75% {
      transform: rotate(210deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `,
  overlayIn: keyframes`
    from {
      opacity: ${opacity.full};
    }
    to {
      opacity: ${opacity.translucent};
    }
  `,
  overlayOut: keyframes`
    from {
      opacity: ${opacity.translucent};
    }
    to {
      opacity: ${opacity.full};
    }
  `,
  overlayContentIn: keyframes`
    from {
      opacity: ${opacity.full};
    }
    to {
      opacity: ${opacity.default};
    }
  `,
  overlayContentOut: keyframes`
    from {
      opacity: ${opacity.default};
    }
    to {
      opacity: ${opacity.full};
    }
  `,
  modalIn: keyframes`
    from {
      opacity: ${opacity.full};
      transform: translateY(100%);
    }
    to {
      opacity: ${opacity.default};
      transform: translateY(0);
    }
  `,
  modalOut: keyframes`
    from {
      opacity: ${opacity.default};
      transform: translateY(0);
    }
    to {
      opacity: ${opacity.full};
      transform: translateY(100%);
    }
  `
};

const Wrapper = styled(Box).attrs({
  w: '100%',
  h: '100%'
})`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${props => props.theme.zIndexes.modal};
`;

const Overlay = styled(Box).attrs({
  w: '100%',
  h: '100%'
})`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${props => props.theme.colors.black};
  animation: ${animations.overlayIn} ${props => props.theme.timings.easeIn}
    forwards;

  .portal-close-animation & {
    animation: ${animations.overlayOut} ${props => props.theme.timings.easeOut}
      forwards;
  }
`;

const BodyWrapper = styled(Box).attrs({
  m: '0 auto'
})`
  position: absolute;
  top: ${props =>
    props.modalWidth === '100%' || !props.modalHeight ? '130px' : '50%'};
  left: ${props =>
    props.modalWidth === '100%' || !props.modalWidth ? '0' : '50%'};
  margin-top: ${props =>
    props.modalWidth === '100%' || !props.modalHeight
      ? '0'
      : -(parseInt(props.modalHeight, 10) / 2)}px;
  margin-left: ${props =>
    props.modalWidth === '100%' || !props.modalWidth
      ? '0'
      : -(parseInt(props.modalWidth, 10) / 2)}px;
  width: ${props => props.modalWidth || 'auto'};
  height: ${props => props.modalHeight || 'auto'};
  max-height: ${props => props.modalHeight || 'none'};
  background-color: ${props => props.theme.colors.white};
  border-radius: ${props => (props.modalWidth === '100%' ? '0' : '8px')};
  box-shadow: 0 24px 80px ${props => props.theme.shadows.modal};
  will-change: opacity;

  animation: ${animations.modalIn} ${props => props.theme.timings.easeIn}
    forwards;
  .portal-close-animation & {
    animation: ${animations.modalOut} ${props => props.theme.timings.easeOut}
      forwards;
  }
`;

const bodyLayoutStyles = css`
  width: 100%;
  height: 100%;
`;

const Body = styled(Box)`
  height: 100%;
  padding: ${props => props.modalPadding};
  ${bodyLayoutStyles};
`;

const Content = styled(Box).attrs({
  m: '0 auto',
  w: '100%',
  h: '100%'
})`
  user-select: ${props => (props.noUserSelect ? 'none' : 'auto')};
`;

const Title = styled(Header)`
  ${props => (props.size === 'normal' ? '' : 'font-size: 20px')};
  ${props => (props.size === 'normal' ? '' : 'line-height: 25px')};
`;

const CloseIcon = styled(Icon).attrs({
  icon: props => (props.size === 'normal' ? 'popupClose' : 'popupCloseSmall')
})`
  position: absolute;
  height: 24px;
  width: 24px;
  padding: 12px;
  cursor: pointer;
  z-index: ${props => props.theme.zIndexes.modal};

  ${props =>
    props.size === 'normal'
      ? css`
          top: 25px;
          right: 24px;
        `
      : css`
          top: 0;
          right: 0;
        `};
`;

export { Wrapper, Overlay, BodyWrapper, Body, Content, Title, CloseIcon };



// WEBPACK FOOTER //
// ./src/components/units/Modal/ModalUnits.js